<!--
 * @Date: 2020-08-26 16:39:31
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-09-14 15:23:24
 * @FilePath: \pc-mall\src\components\CopyRight.vue
-->
<template>
  <div class="footer">
    <footer class="footer-contant">
      <p class="copyright-text">佛山市南海区西樵山森林公园旅游开发总公司 丨 ICP备案：粤ICP备17004298号 丨 Copyright © 2016 Xiqiao mountain All Rights Reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  created () {
    console.log('s')
  }
}
</script>

<style scoped>
.footer {
  width: 100%;
  height: 50px;
  background: #9B232A;
  position: absolute;
  bottom: 0;
}
.footer-contant {
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 50px;
  color: #FFFFFF;
}
</style>
